import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, X, Users, Dumbbell, UtensilsCrossed, Snowflake, Megaphone, BookOpen } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const actions = [
  { label: 'Add Client', icon: Users, color: '#00C8FF', to: '/admin/clients' },
  { label: 'Create Workout', icon: Dumbbell, color: '#65A30D', to: '/admin/training' },
  { label: 'Add Food', icon: UtensilsCrossed, color: '#FFB800', to: '/admin/foods' },
  { label: 'Recovery Protocol', icon: Snowflake, color: '#7DD3FC', to: '/admin/recovery' },
  { label: 'Send Broadcast', icon: Megaphone, color: '#FF6FA8', to: '/admin/broadcasts' },
];

export function AdminFAB() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const go = (to) => { setOpen(false); nav(to); };
  return (
    <>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
            className="fixed inset-0 bg-black/60 z-30 backdrop-blur-sm" />
        )}
      </AnimatePresence>
      <div className="fixed bottom-20 lg:bottom-6 right-5 z-40 flex flex-col items-end gap-3">
        <AnimatePresence>
          {open && actions.map((a, i) => (
            <motion.button
              key={a.label}
              initial={{ opacity: 0, x: 20, scale: 0.8 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: 20, scale: 0.8 }}
              transition={{ delay: i * 0.04 }}
              onClick={() => go(a.to)}
              data-testid={`fab-${a.label.toLowerCase().replace(/\s+/g, '-')}`}
              className="flex items-center gap-3 pl-4 pr-3 py-2.5 rounded-full bg-[var(--c-elev)] border border-[var(--c-hair)] shadow-2xl"
            >
              <span className="text-sm font-medium whitespace-nowrap">{a.label}</span>
              <div className="w-9 h-9 rounded-full flex items-center justify-center" style={{ background: `${a.color}1a`, color: a.color }}>
                <a.icon className="w-4 h-4" />
              </div>
            </motion.button>
          ))}
        </AnimatePresence>
        <button
          onClick={() => setOpen(o => !o)}
          data-testid="admin-fab"
          className={`w-14 h-14 rounded-full flex items-center justify-center shadow-[0_8px_32px_rgba(0,200,255,0.5)] transition-all ${open ? 'rotate-45 bg-[var(--c-film)]' : 'bg-[#00C8FF]'}`}
        >
          {open ? <X className="w-6 h-6" /> : <Plus className="w-6 h-6 text-[#081726]" strokeWidth={3} />}
        </button>
      </div>
    </>
  );
}
